// extracted by mini-css-extract-plugin
export default {"raiDots":"DotsIndicator_raiDots__zS2XT","fullHeight":"DotsIndicator_fullHeight__uEC5s","raiCircle":"DotsIndicator_raiCircle__YfgMv","dots-pulse":"DotsIndicator_dots-pulse__OjFAl"};